module.exports = __webpack_public_path__ + "img/17.fa42c349.png";